










import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { AssetsModule, SingleAssetUsage, AssetFile, isSelectable } from '@/store/modules/asset'
import PrimaryButtons from "@/components/products/framepuzzle/FramePuzzlePrimaryButtons.vue"
import DesignPuzzleImage from "@/components/products/framepuzzle/steps/DesignPuzzleImage.vue"
import PuzzleOverlayUpload from "@/components/products/framepuzzle/steps/PuzzleOverlayUpload.vue"
import { FramePuzzleModule, CollageInfo, PuzzleFormat, PuzzleBoxUpdateState } from '../../../../store/modules/framePuzzle'
import { ToolbarModule } from '@/store/modules/toolbar'
import { AppModule } from '@/store/modules/app'
import { ErrorsModule } from '../../../../store/modules/error'

@Component({
    name: 'design-puzzle',
    components: {
        DesignPuzzleImage,
        PuzzleOverlayUpload,
        PrimaryButtons
    },
})

export default class DesignPuzzle extends Vue {
    @Prop() private optional!: boolean

    public displayOverlayUpload = false
    private oldFormat = FramePuzzleModule.format
    private oldUserFormat = FramePuzzleModule.userFormat
    private confirmableImage = false

    get showOverlayUpload() {
        return FramePuzzleModule.showOverlayUpload
    }

    get filesLoading() {
        let filesLoading = false
        AssetsModule.assets.forEach(file => {
            if (!isSelectable(file)) {
                filesLoading = true
            }
        })
        return filesLoading
    }


    @Watch('showOverlayUpload')
    showOverlayUploadChanged(newShowOverlayUpload: boolean) {
        this.displayOverlayUpload = newShowOverlayUpload
    }

    mounted() {
        this.persistPuzzle()
    }

    persistPuzzle() {
        Object.keys(FramePuzzleModule.persistedAssets).forEach(key => {
            FramePuzzleModule.ClearPersistedAssetData(key)
        })
        Object.keys(FramePuzzleModule.activeAssets).forEach(key => {
            let asset = FramePuzzleModule.activeAssets[key]
            let usage = asset.usage[key] as SingleAssetUsage
            let info = FramePuzzleModule.allCollages[key] as CollageInfo
            if (info !== undefined && usage !== undefined && asset !== undefined) {
                FramePuzzleModule.SetPersistedAsset([key, asset])
                FramePuzzleModule.PersistNameAndUsage([key, usage])
                FramePuzzleModule.PersistCollageUsageAndInfo([key, info])
            }
        })
    }

    recoverPuzzle() {
        FramePuzzleModule.SetRecoverPuzzleToggled(!FramePuzzleModule.recoverPuzzleToggled)
    }

    cancelOverlayUpload() {
        (this.$refs.overlayUpload as PuzzleOverlayUpload).onCancel()
    }

    closeOverlayUpload() {
        (this.$refs.overlayUpload as PuzzleOverlayUpload).onClose()
    }

    confirmPuzzleImage() {
        (this.$refs.puzzleImage as DesignPuzzleImage).confirm()
    }

    onCancel() {
        if (ToolbarModule.error) {
            ToolbarModule.SetToolbarError(false)
        }
        if (ToolbarModule.errorKeys.length > 0) {
            ToolbarModule.UnsetErrorKey("frameimage")
        }
        if (ErrorsModule.keys.length > 0) {
            ErrorsModule.SetError({ key: "frameimage" })
        }
        FramePuzzleModule.SetPuzzleBoxUpdateState(PuzzleBoxUpdateState.UPDATED)
        FramePuzzleModule.SetShowOverlayUpload(false)
        this.recoverPuzzle()
        FramePuzzleModule.SetPuzzleFormat(this.oldFormat)
        FramePuzzleModule.SetUserFormat(this.oldUserFormat)
        this.cancelOverlayUpload()
        this.$emit('cancel')
    }

    onConfirm() {
        if (this.oldFormat !== FramePuzzleModule.format) {
            FramePuzzleModule.SetResetFrameDesignToggled(!FramePuzzleModule.resetFrameDesignToggled)
        }
        if (this.confirmableImage) {
            this.confirmPuzzleImage()
            this.$nextTick(() => {
                this.$emit('confirm')
                FramePuzzleModule.SetShowOverlayUpload(false)
                if (!AppModule.steps[0].completed) {
                    AppModule.CompleteStep(0)
                }
                return
            })
        }
    }

    onClose() {
        FramePuzzleModule.SetShowOverlayUpload(false)
    }

    onConfirmableImageChanged(confirmable: boolean) {
        this.confirmableImage = confirmable
    }

    confirmable() {
        return this.confirmableImage
    }

    goToMenu() {
        this.onCancel()
    }
}
